import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';
import moment from 'moment';

import '../../theme/global.scss';
import styles from '../../pages/monitorization/monitorization.module.scss';
import {
  ILitigation,
  ILitigationArchiveDocument,
  ILitigationDocument
} from '../../utils/interfaces/interfaces';
import { formatDate } from '../../utils/strings';
import CDropdown from '../dropdown/dropdown';
import {
  checkFilesHaveSameType,
  combineFiles,
  fileFormat,
  handleFileChange,
  initialFile
} from '../../utils/files';
import CSwitch from '../switch/switch';
import CUpload from '../input/upload';
import { notify } from '../../notifications/notification';
import { typesFiles } from '../../types/uploaded-data';
import { TermPeriods, types_TermPeriods } from '../../types/litigations';
import {
  addLitigationArchiveDocument,
  addLitigationDocument,
  updateLitigationDocument
} from '../../network/litigii';
import { endOfTerm } from '../../utils/termCalculator';

interface IEditLitigationDocumentProps {
  callback?: () => void;
  litigation: ILitigation;
}

const initialForm: ILitigationArchiveDocument = {
  id: 0,
  litigationId: 0,
  name: '',
  document: fileFormat
};

const EditLitigationArchiveDocument = (props: IEditLitigationDocumentProps) => {
  const [form, updateForm] = useState(initialForm);

  const [document, setDocument] = useState(initialFile);
  const [error, setError] = useState('');

  useEffect(() => {
    updateForm(form => ({ ...form, decisionId: props.litigation.id }));
  }, [props.litigation]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target) {
      const { value, name } = event.target;
      updateForm(form => ({ ...form, [name]: value }));
    }
  };

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      if (!checkFilesHaveSameType(event.target.files, typesFiles.pdf)) {
        notify('Trebuie sa incarcati documente de tip PDF', 'info');
        return;
      }
    }
    handleFileChange(event, setFile);
  };

  const handleSubmit = async (event: React.MouseEvent) => {
    event.preventDefault();
    console.log(form);
    setError('');

    // setError('Trebuie sa completati toate campurile');

    const decisionDocument = await combineFiles(document, form.name);

    addLitigationArchiveDocument({
      ...form,
      litigationId: props.litigation.id,
      document: decisionDocument
    }).then(() => {
      notify('Ati salvat documentul', 'success');
      props.callback && props.callback();
    });
  };

  return (
    <form>
      <p className='body-dark bold'>Adaugare document arhiva electronică</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      {error && <p className='body-dark error'>{error}</p>}

      <>
        <CInput
          label='Nume document'
          type='text'
          id='name'
          placeholder='Numele documentului'
          name='name'
          value={form.name}
          onChange={handleChange}
          required
        />
        <CUpload
          label='Încărcați documentul'
          title='Încărcați documentul'
          id='document'
          name=''
          value={document}
          onChange={e => handleFile(e, setDocument)}
        />
      </>

      <Space vertical={'30px'} />
      <CButton label='Salveaza' type='submit' onClick={handleSubmit} />
    </form>
  );
};

export default EditLitigationArchiveDocument;
